import { createSlice } from "@reduxjs/toolkit";

export type State = {
  currentPeriod: Date | undefined;
}

export type Actions = {  
}

const initialState: State = {
    currentPeriod: undefined,
}

export const uiStore = createSlice({
    name: 'ui',
    initialState,
    reducers: {
      setCurrentPeriod: (state: State, action: { payload: Date }) => {
        state.currentPeriod = action.payload;
      },
    }
});

export const {
  setCurrentPeriod
} = uiStore.actions;

export default uiStore.reducer;